export default __webpack_public_path__ + "static/media/paymentsTitleIcon.dec340f5.png";